"use strict";var merge=require("merge"),isObject=require("lodash.isobject"),isArray=require("lodash.isarray");module.exports=function(e){return isObject(e)&&!isArray(e)?e:1===e.length?e[0]:merge.recursive.apply(void 0,e)};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactcss/lib/merge-classes.js
 ** module id = 887
 ** module chunks = 0
 **/